// Adsterra Native Banner。脚本会找固定 container id 并往里灌广告;
// 靠近视口时加载;SPA 切模式时移除旧脚本,重新挂载即可再次执行。
import { useEffect, useRef, useState } from 'react';

const AD_ID = '542cd29159493faa2a0e207f0ae40a5d';
// 用户于 2026-10-03 从 Adsterra 后台提供的原始 src;不要自行改写域名或路径。
const SRC = 'https://bauval.org/21/542cd29159493faa2a0e207f0ae40a5d';

export default function NativeBanner() {
  const box = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const slot = box.current;
    if (!slot) return;

    let disposed = false;
    let attempts = 0;
    let script: HTMLScriptElement | undefined;
    let retry: ReturnType<typeof setTimeout> | undefined;
    let observer: IntersectionObserver | undefined;

    function load() {
      if (disposed) return;
      attempts += 1;
      script = document.createElement('script');
      script.async = true;
      script.setAttribute('data-cfasync', 'false');
      // 保留广告平台提供的 URL;再次插入同 URL 的 script 仍会执行,无需随机参数。
      script.src = SRC;
      script.onerror = () => {
        if (disposed) return;
        script?.remove();
        if (attempts < 2) retry = setTimeout(load, 1500);
        else {
          slot!.replaceChildren();
          setFailed(true);
        }
      };
      document.body.appendChild(script);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer?.disconnect();
          load();
        }
      }, { rootMargin: '300px' });
      observer.observe(slot);
    } else {
      load();
    }

    return () => {
      disposed = true;
      observer?.disconnect();
      clearTimeout(retry);
      if (script) {
        script.onerror = null;
        script.remove();
      }
      slot.replaceChildren();
    };
  }, []);

  return (
    <aside className="native-banner" aria-label="Sponsored" hidden={failed}>
      <div ref={box} id={`container-${AD_ID}`} />
    </aside>
  );
}
